<template>
  <vs-chip class="ag-grid-cell-chip chip">
    <span>{{ status }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: "EntityRendererStatus",
  computed: {
    status() {
      return this.params.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
.chip {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  font-weight: 500;
}
</style>
